import { OptionalObjectSchema } from 'yup/lib/object';
import * as Yup from 'yup';
import { LanguageCode } from 'i18n/internationalization.types';
import { TemplateSettings } from 'models/automation/TemplateSettings';
import { LANGUAGES } from './ManageLanguages.constants';

export const manageLanguagesModalSchema = () => ({
  locales: Yup.object().shape({
    ...LANGUAGES.reduce(
      (acc, language) => ({
        ...acc,
        [language]: Yup.boolean().required(),
      }),
      {} as Record<LanguageCode, Yup.BooleanSchema>,
    ),
  }),
  autoTranslate: Yup.boolean().required(),
});

export type ManageLanguagesModalFormValues = Yup.InferType<
  OptionalObjectSchema<ReturnType<typeof manageLanguagesModalSchema>>
>;

export const getFormDefaultValues = ({
  templateSettings,
}: {
  templateSettings: TemplateSettings | undefined;
}): ManageLanguagesModalFormValues => {
  return {
    locales: LANGUAGES.reduce((acc, language) => {
      if (language === LanguageCode.EN) {
        acc[language] = true;
      } else {
        acc[language] = templateSettings?.locales?.includes(language) ?? false;
      }

      return acc;
    }, {} as ManageLanguagesModalFormValues['locales']),
    autoTranslate: templateSettings?.autoTranslate ?? false,
  };
};
